module.exports = __webpack_public_path__ + "static/media/roadRate.2c710d0b.png";